import React from "react";

const FAQSection = () => {
  const faqs = [
    {
      question: "Quels types de véhicules proposez-vous ?",
      answer:
        "Nous proposons une large gamme de véhicules, y compris des voitures neuves et d'occasions, des SUV, des berlines et des véhicules électriques.",
    },
    {
      question: "Proposez-vous des services après-vente ?",
      answer:
        "Oui, nous offrons des services après-vente complets, y compris la maintenance, les réparations et la fourniture de pièces détachées.",
    },
    {
      question:
        "Que signifie l'année derrière la voiture sur le site ? Est-ce une voiture d'occasions ?",
      answer:
        "L'année qui suit le titre de la voiture représente l'année du nom de la version de la voiture, et non son année de production. Si on ne précise pas qu’il s’agit d’une voiture d’occasions, alors c’est une toute neuve. Nos voitures d’occasions le préciseront clairement. Cependant, si vous souhaitez acheter une voiture d'occasions, vous pouvez également nous contacter et nous pourrons rechercher une source de voitures d'occasions en fonction de vos besoins.",
    },
    {
      question: "Comment déterminer le prix d’une voiture ?",
      answer:
        "Nous sélectionnons la source de la voiture en comparant les devis de différents concessionnaires et en tenant compte de l'état de la voiture et des conditions du marché. Cela nous permet de vous offrir le prix le plus compétitif.",
    },
    {
      question:
        "Avez-vous les qualifications nécessaires pour exporter des voitures ?",
      answer:
        "Oui, nous avons les qualifications nécessaires pour l’exportation d’automobiles et pouvons vous fournir un service d’achat de voitures à guichet unique.",
    },
  ];

  return (
    <section className="faq-section py-5">
      <div className="container">
        <h1 className="text-center" style={{ backgroundColor: "whitesmoke" }}>
          Plus de questions que vous pourriez avoir
        </h1>
        <h2 className="text-center mb-4">Foire Aux Questions</h2>

        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="accordion-item" key={index}>
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded="false"
                  aria-controls={`collapse${index}`}
                >
                  {faq.question}
                </button>
              </h2>

              <div
                id={`collapse${index}`}
                className="accordion-collapse collapse"
                aria-labelledby={`heading${index}`}
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">{faq.answer}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;